import React from 'react';
import { Tab } from 'semantic-ui-react';
import Pane from './Pane.js';
import { generate } from 'shortid';


const languages = [
  { lang: 'et', text: 'Eesti keel' },
  { lang: 'en', text: 'English'}
];

const I18nTabs = (props) => {
  const data = props.data || [];
  
  return (
    <div>
      <Tab
        defaultActiveIndex={0}
        panes={languages.map(({lang, text}) => {
          return {
            key: generate(),
            menuItem: text,
            render: () =>
              <Pane key={generate()} lang={lang} data={data} onChange={props.onChange}/>
          };
        })} />
    </div>
  );
};

export default I18nTabs;



// WEBPACK FOOTER //
// ./src/private/common/components/I18nTabs/index.js